import { Heading4 } from '@sb1/ffe-core-react';
import { formatMoneyKr } from '../../../utils';

import styles from './custom-SBNN-selection-header.module.less';

const CustomSBNNSelectionHeader = ({ collectedAmountWithoutMatching, matchingAmount, totalCollectedAmount }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.column}>
                <Heading4>Det er samlet inn</Heading4>
                <Heading4 lookLike={2}>{formatMoneyKr(collectedAmountWithoutMatching)}</Heading4>
            </div>
            <div className={styles.column}>
                <Heading4> SpareBank 1 Nord-Norge matcher med</Heading4>
                <Heading4 lookLike={2}>{formatMoneyKr(matchingAmount)}</Heading4>
            </div>
            <div className={styles.column}>
                <Heading4>Totalt innsamlet beløp</Heading4>
                <Heading4 lookLike={2}>{formatMoneyKr(totalCollectedAmount)}</Heading4>
            </div>
        </div>
    );
};

export default CustomSBNNSelectionHeader;
